<template>
  <div class="empty">
    <img
      v-if="image"
      :src="`/assets/images/empty/${image}.svg`"
      alt="empty"
      class="img-size"
      :class="['img-size--' + imageSize]"
    />
    <h1 class="title">{{ title }}</h1>
    <p class="text-center mt-3">{{ description }}</p>
  </div>
</template>

<script lang="ts">
export default {
  name: 'HMEmpty',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: { type: String, required: true },
    image: {
      type: String,
      default: 'empty-orders',
    },
    imageSize: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.empty {
  margin: auto;
  margin-top: 1rem;
  max-width: 450px;
  text-align: center;

  .img-size {
    width: 80%;

    &--small {
      width: 50%;
    }
  }
}
.title {
  font-weight: 700;
  margin-top: 2rem;
  line-height: 54px;
}
</style>
